export const VerticalItemHeight = 300;
